import { useState, useEffect } from 'react';
import { CourseCategory } from '@/types/data';

interface UseFeaturedCategoriesReturn {
  categories: CourseCategory[];
  loading: boolean;
  error: string | null;
}

export const useFeaturedCategories = (): UseFeaturedCategoriesReturn => {
  const [categories, setCategories] = useState<CourseCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFeaturedCategories = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetch('/api/featured-categories');
        const data = await response.json();

        if (data.success) {
          setCategories(data.data);
        } else {
          setError(data.error || 'Failed to fetch featured categories');
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch featured categories');
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedCategories();
  }, []);

  return { categories, loading, error };
};